export default __webpack_public_path__ + "static/media/3.d776db48.jpeg";